export const HOTKEYS_DISABLED = 'DISABLED';
